<template>
    <div class="container">
        <template v-if="isPageReady && currentDataId">
            <who-are-you
                :id="currentDataId"
                @show-logged-user-profile="currentDataId = loggedUser.id_person" />
        </template>
    </div>
</template>

<script>
// @ is an alias to /src
//
import Vue from "vue";
import { userGroupInfo } from "@/utils/api/groupsApi.js";
import { getGroupTypeName, getGroupTypeColor } from "@/utils/helpers/group.js";
import { capitalize } from "@/utils/helpers/string.js";

import WhoAreYou from "@/components/profiling/WhoAreYou.vue";

export default {
    name: "Profiling",
    components: {
        "WhoAreYou": WhoAreYou
    },
    props: {
        partnerId: {
            type: String,
            required: false,
            default: null
        },
    },
    data() {
        return {
            isPageReady: false
        };
    },
    computed: {
        // currentDataId
        // Current data (user of group) id to display
        currentDataId() {
            return this.$store.getters["globalModule/getCurrentDataId"];
        },
        // loggedUser
        // Current logged user
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        // groups
        // User groups info
        groups() {
            return this.$store.getters["userModule/getGroups"];
        },
    },
    mounted() {
        // User Groups
        this.fetchGroups();
    },
    methods: {
        // Fetch User Groups Info
        fetchGroups() {
            const user = {
                "id": this.loggedUser.id_person
            };

            let datasOptions = [];

            datasOptions.push({
                "value": this.loggedUser.id_person,
                "label": this.$t("yourself") + ": " +this.loggedUser.fname
            });

            userGroupInfo(user).then((res) => {
                if (res.status === 200 && res.data) {
                    if (res.data.message === "no group for user") {
                        this.$store.commit("userModule/setGroups", null);
                    } else {
                        this.$store.commit("userModule/setGroups", res.data);
                        const groups = res.data;


                        groups.forEach((group) => {

                            const currentGroupUsers = this.getGroupMember(group);

                            if (currentGroupUsers) {

                                datasOptions.push({
                                    "value": group.id_group,
                                    "label": this.$t(getGroupTypeName(group.id_group_type)),
                                    "disabled": true
                                });

                                currentGroupUsers.forEach((user) => {
                                    datasOptions.push({
                                        "value": user.id,
                                        "label": this.capitalize(user.name)
                                    });
                                });
                            }

                        });
                    }

                    if (datasOptions.length > 0) {
                        this.$store.commit("globalModule/setAvailableDatas", datasOptions);

                        Vue.nextTick(() => {
                            this.isPageReady = true;
                            if (this.partnerId) {
                                this.$store.commit("globalModule/setCurrentDataId", this.partnerId);
                            }
                        });
                    }
                }
            });
        },
        getGroupMember(group) {
            let members = [];

            if (group && group.id_person_2) {

                const membersIdArray = group.id_person_2.split(",");
                const membersNameArray = group.name.split(",");

                for (var i = membersIdArray.length - 1; i >= 0; i--) {

                    const member = {
                        id: membersIdArray[i],
                        name: membersNameArray[i]
                    };

                    members.push(member);
                }
            }

            const sorteArray = members.sort(function(a, b) {
                var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                var nameB = b.name.toUpperCase(); // ignore upper and lowercase

                if (nameA < nameB) {
                    return -1; //nameA comes first
                }

                if (nameA > nameB) {
                    return 1; // nameB comes first
                }

                return 0;  // names must be equal
            });

            return sorteArray;
        },
    }
};
</script>
